import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  formatDateTime,
} from "../common-data/Converts";
import DFPMLinksMobile from "./DFPMLinksMobile";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  EyeIcon,
  XCircleIcon,
} from "../../images/icons/icons";

const DFPaymentLinks = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
}) => {
  const { dfPaymentsData, dfPaymentsLoading } = useSelector(
    (state) => state.payment
  );

  const isShowPmLink =
    userInfoData?.account_type === "admin" ||
    userInfoData?.account_type === "cluster_manager";
  const isAdmin = userInfoData?.account_type === "admin";

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (dfPaymentsData?.status && dfPaymentsData?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: dfPaymentsData.data,
        pagination:
          dfPaymentsData?.pagination?.length > 0
            ? dfPaymentsData.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [dfPaymentsData]);

  const tbColumns = [
    isShowPmLink && {
      text: "Payment Link",
      formatter: (_, row) => {
        const isNotPending = row?.status !== "pending";

        return (
          <span
            className="tb-data text-primary icon minWidth100"
            style={{ textDecoration: "underline", textTransform: "lowercase" }}
          >
            {isNotPending ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-box-arrow-up-right"
                viewBox="0 0 16 16"
                style={{
                  cursor: "not-allowed",
                  opacity: 0.5,
                }}
              >
                <path
                  fillRule="evenodd"
                  d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                />
                <path
                  fillRule="evenodd"
                  d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                />
              </svg>
            ) : row?.payment_link ? (
              <a
                className=""
                rel="noreferrer"
                target="_blank"
                href={row.payment_link}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-box-arrow-up-right"
                  viewBox="0 0 16 16"
                  style={{
                    cursor: "pointer",
                    opacity: 1,
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                  />
                  <path
                    fillRule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                  />
                </svg>
              </a>
            ) : (
              <CrossCircleIcon />
            )}
            <br />
            {row?.payment_mode || ""}{" "}
            {row?.payment_location && (
              <small className="underline">
                ({row.payment_location === "gym" ? "Inside Gym" : "Outside Gym"}
                )
              </small>
            )}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Payment Status",
      formatter: (_, row) => {
        const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();

        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius27"
            style={{
              background:
                planStatus === "completed"
                  ? "#379C00"
                  : planStatus === "pending"
                  ? "#EB8317"
                  : "#D90000",
              color: "#fff",
            }}
          >
            {!isShowPmLink && planStatus === "pending"
              ? "Link Sent"
              : row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_id",
      text: "Member",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.user_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
                textDecoration: "underline",
              }}
            >
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
            {row?.experience_level && (
              <>
                <br />
                <small className="gray underline">
                  {row?.experience_level}
                </small>
              </>
            )}
          </span>
        );
      },
    },
    {
      dataField: "plan_id",
      text: "Plan",
      formatter: (_, row) => {
        const isPT = row?.plan_type === "addont_pt";
        const isPartial = row?.payment_mode === "partial";

        return (
          <span
            className={`tb-data minWidth150 ${isPartial ? "link" : ""}`}
            onClick={
              isPartial
                ? () =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "partial_details",
                      rowData: row,
                    }))
                : null
            }
          >
            {row?.plan_name || "NA"}
            <br />
            <b> ₹{convertThenFormat(row?.plan_price || 0)}</b>
            {!isPT && (
              <>
                <br />({row?.extend_days || 0} days)
              </>
            )}
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "created_by",
      text: "created by",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.created_by_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
                textDecoration: "underline",
              }}
            >
              {row?.created_by_mobile || ""}
              <br />
              {row?.created_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "wap_sent",
      text: "Message Sent",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.wap_sent ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "wap_delivered",
      text: "Message delivered",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.wap_delivered ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "wap_read_status",
      text: "Message read",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.wap_read_status ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "plan duration",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100 underline">
            {row?.start_date ? convertStraight(row.start_date) : "-"}
            <br />
            {row?.expire_date ? convertStraight(row.expire_date) : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "extend_days",
    //   text: "extend days",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?.extend_days || 0}</span>;
    //   },
    // },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "view details",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            account_type="button"
            className="actionBtn icon"
            disabled={false}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
              }))
            }
          >
            <EyeIcon />
          </button>
        </div>
      ),
    },
    isAdmin && {
      dataField: "dynamic_link_url",
      text: "Website Payment Link",
      formatter: (_, row) => {
        const isPending = row?.status === "pending";

        return (
          <span
            className="tb-data text-primary icon"
            style={{ textDecoration: "underline", textTransform: "lowercase" }}
          >
            {row?.dynamic_link_url ? (
              <>
                {isPending ? (
                  <a
                    className=""
                    rel="noreferrer"
                    target="_blank"
                    href={row.dynamic_link_url}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-box-arrow-up-right"
                      viewBox="0 0 16 16"
                      style={{
                        cursor: "pointer",
                        opacity: 1,
                      }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                      />
                      <path
                        fillRule="evenodd"
                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                      />
                    </svg>
                  </a>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-box-arrow-up-right"
                    viewBox="0 0 16 16"
                    style={{
                      cursor: "not-allowed",
                      opacity: 0.5,
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                    />
                    <path
                      fillRule="evenodd"
                      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                    />
                  </svg>
                )}
              </>
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "dynamic_link_url",
      text: "App Payment Link",
      formatter: (_, row) => {
        const isPending = row?.status === "pending";

        const handleCopyLink = async (event) => {
          event?.stopPropagation?.();

          if (row?.dynamic_link_url) {
            try {
              if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(row.dynamic_link_url);
              } else {
                const textArea = document.createElement("textarea");
                textArea.value = row.dynamic_link_url;
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                  document.execCommand("copy");
                } catch (err) {
                  console.error("Fallback: Oops, unable to copy", err);
                }

                document.body.removeChild(textArea);
              }

              const toast = document.createElement("div");
              toast.textContent = "Link copied!";
              toast.style.cssText = `
                position: fixed;
                top: 20px;
                right: 20px;
                background: #379C00;
                color: white;
                padding: 12px 24px;
                border-radius: 4px;
                font-size: 14px;
                z-index: 9999;
                box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                animation: fadeInOut 2s ease-in-out;
              `;

              const style = document.createElement("style");
              style.textContent = `
                @keyframes fadeInOut {
                  0% { opacity: 0; transform: translateY(-20px); }
                  15% { opacity: 1; transform: translateY(0); }
                  85% { opacity: 1; transform: translateY(0); }
                  100% { opacity: 0; transform: translateY(-20px); }
                }
              `;
              document.head.appendChild(style);
              document.body.appendChild(toast);

              setTimeout(() => {
                toast.remove();
                style.remove();
              }, 2000);
            } catch (err) {
              console.error("Failed to copy link:", err);
            }
          }
        };

        return (
          <span
            className="tb-data text-primary icon minWidth150"
            style={{
              textDecoration: "underline",
              position: "relative",
              textTransform: "capitalize",
            }}
          >
            {row?.dynamic_link_url ? (
              <>
                {isPending ? (
                  <button
                    type="button"
                    onClick={handleCopyLink}
                    className="btn btn-outline-primary capitalize"
                  >
                    Click to Copy
                  </button>
                ) : (
                  <button
                    type="button"
                    disabled
                    className="btn btn-outline-primary capitalize"
                    style={{
                      cursor: "not-allowed",
                      opacity: 0.5,
                    }}
                  >
                    Click to Copy
                  </button>
                )}
              </>
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
        {dfPaymentsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        <DFPMLinksMobile
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          loading={dfPaymentsLoading}
          setModValues={setModValues}
          isShowPmLink={isShowPmLink}
          isAdmin={isAdmin}
        />
      </div>
    </>
  );
};

export default DFPaymentLinks;
